import React from "react";
import { Box, Card, CardContent } from "@material-ui/core";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CardHeading from "src/components/CardHeader/CardHeader";
import TabHeader from "src/components/TabHeader/TabHeader";
import { useStyles } from "./styles";

type Props = {
  module: string;
  children: any;
  heading: string;
  GridDataComp?: any;
  linkTo?: string;
};

export default function CommonDataGridPage({
  module,
  children,
  heading,
  GridDataComp,
  linkTo,
}: Props) {
  const classes = useStyles();
  const { height } = UseWindowDimensions();
  let wHeight = 0;
  wHeight = height - 207;
  return (
    <>
      <TabHeader module={module || "module"} heading={heading || "heading"} linkTo={linkTo} />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: wHeight }}>
          <CardHeading heading={heading || "heading"} />
          <Box mt={1}>{children}</Box>
          {GridDataComp && GridDataComp}
        </CardContent>
      </Card>
    </>
  );
}
